
import { EditedParticipation } from "../../../Partner/EditedPartner";
import { Filter } from "../../ParticipationFunctions/Filtering";
import { offsetOneRow, offsetTwoRows, StateStyledCell } from "../../Styles/ParticipationTableStyles";
import { CellWithValidator, StickyHeader, StickyNumericHeader } from "../../../../components/Table/TableStyles";
import { ValidatedIcon, ValidateFilter, ValidateFilterValue } from "../../../../components/Controls/ValidateControl";
import { NumericFilter } from "../../../../components/Form/FormStyles";

export function TTFAgreementNumberHeader() {
	return (
		<StickyHeader
			style={{
				...offsetOneRow,
				width: '220px',
				minWidth: '220px',
				maxWidth: '220px'
			}}>
			TTF agreement number
		</StickyHeader>
	)
}

export function TTFAgreementNumberFilter({ filter, updateFilter }: { filter: Filter, updateFilter: (filter: Filter) => void }) {
	return (
		<StickyNumericHeader style={{ ...offsetTwoRows }}>
			<CellWithValidator>
				<ValidateFilter
					value={
						filter?.TTFAgreementNumberValidated ?? ValidateFilterValue.Unset
					}
					onChange={(e) =>
						updateFilter({ ...filter, TTFAgreementNumberValidated: e.value })
					}
				/>
				<NumericFilter
					value={filter?.TTFAgreementNumber ?? ''}
					onChange={(e) =>
						updateFilter({ ...filter, TTFAgreementNumber: e.target.value })
					}
				/>
			</CellWithValidator>
		</StickyNumericHeader>
	)
}

export function TTFAgreementNumberContent({ ppn }: { ppn: EditedParticipation }) {
	return (
		<StateStyledCell
			editStatus={ppn.EditStatus}
			modified={ppn.PlantingProjectId.modified}>
			<CellWithValidator>
				<span>
					{ppn.PlantingProject.TTFAgreementNumberValidated && (
						<ValidatedIcon />
					)}
				</span>
				<span>{ppn.PlantingProject.TTFAgreementNumber}</span>
			</CellWithValidator>
		</StateStyledCell>
	)
}